<template>
    <div class="analytics-tags-filter">
        <ds-multiselect
            v-model="filter.value"
            multiple
            searchable
            placeholder="Search tags"
            bind-value-only
            :options="availableTagOptions"
        />
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        value: Object,
        tags: Array,
    },

    data() {
        return {
            filter: this.value,
            allTags: [],
        };
    },

    created() {
        this.fetchAllTags();
    },

    watch: {
        value: {
            handler(value) {
                this.filter = value;
            },
            deep: true,
        },

        filter: {
            handler() {
                this.updateQuery();
            },
            deep: true,
        },

        'filter.modifier': function() {
            this.filter.value = '';
        },
    },

    computed: {
        availableTagOptions() {
            let availableTags = this.allTags
                .map(({ category, name, id }) => {
                    return {
                        category: category.name || 'Uncategorized',
                        value: id,
                        label: name,
                    };
                })
                .sort((firstTag, secondTag) => {
                    return firstTag.category < secondTag.category ? -1 : firstTag.category > secondTag.category ? 1 : 0;
                })
                .reduce((previous, current) => {
                    const key = current.category;

                    if (previous[key]) {
                        previous[key].options.push({ value: current.label, label: current.label });
                    } else {
                        previous[key] = {};
                        previous[key].options = [];
                        previous[key].label = key;
                        previous[key].options.push({ value: current.label, label: current.label });
                    }

                    return previous;
                }, []);

            availableTags = Object.keys(availableTags).map((element) => {
                return availableTags[element];
            });

            return availableTags;
        },
    },

    methods: {
        updateQuery() {
            let query = '';

            if (Array.isArray(this.filter.value) && this.filter.value.length > 0) {
                switch (this.filter.modifier) {
                case 'includesany':
                    query = this.filter.value.join(',');
                    break;
                case 'excludesall':
                    query = this.filter.value
                        .map((value) => `-${value}`)
                        .join(',');
                    break;
                default:
                    break;
                }
            }

            this.filter.query = query;
        },

        async fetchAllTags() {
            if (this.allTags.length) {
                return;
            }

            try {
                const { data } = await axios.get('/app/contactGroup/allTags?limit=1000&offset=0');

                this.allTags = data;
            } catch (e) {
                this.$error({ message: 'Unable to fetch the tags' });
            }
        },
    },
};
</script>
